import {
  setActiveSortingType,
  setFilteredProducts,
} from "features/category/categorySlice";
import {
  setActiveFilters,
  setActiveFiltersCount,
} from "features/Filters/filtersSlice";
import { setPage } from "features/pagination/paginationSlice";
import { SortingType } from "pages/category/types";
import React, { memo } from "react";
import { batch, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { device } from "theme/Breakpoints";
import { smallShadow } from "theme/GlobalElements";

interface PartnersItemProps {
  item: any;
}

const PartnersItem: React.FC<PartnersItemProps> = ({ item }) => {
  const dispatch = useDispatch();
  const navigateTo = () => {
    batch(() => {
      batch(() => {
        dispatch(setActiveSortingType(SortingType.priceasc));
        dispatch(setActiveFilters([]));
        dispatch(setPage(1));
        dispatch(setActiveFiltersCount(1));
        dispatch(setFilteredProducts([]));
      });
    });
  };
  return (
    <PartnersItemContainer
      to={`/category?brand=${item.name}`}
      onClick={navigateTo}
    >
      <Wrapper>
        <ImageContainer>
          <Image src={`assets/partners/${item.image}`} />
        </ImageContainer>
      </Wrapper>
    </PartnersItemContainer>
  );
};

const PartnersItemContainer = styled(Link)`
  cursor: pointer;
  padding-top: 36%;
  position: relative;
  grid-row-start: span 1;
  grid-row-end: span 1;
  grid-column-start: span 1;
  grid-column-end: span 1;
  width: 100%;
  height: 0;
  background-color: white;
  @media only screen and (${device.laptop}) {
    transition: 0.3s;
    &:hover {
      transform: scale(1.1);
      ${smallShadow};
    }
  }
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const ImageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  &:hover {
    & > img {
      filter: none;
      -webkit-filter: grayscale(0%);
    }
  }
`;

const Image = styled.img`
  max-width: 60%;
  max-height: 40%;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  filter: url("data:image/svg+xml;utf8,<svg version='1.1' xmlns='http://www.w3.org/2000/svg' height='0'><filter id='greyscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0' /></filter></svg>#greyscale");
`;

export default memo(PartnersItem);
